import {NgModule} from '@angular/core';

import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

// !ANGULAR MAT
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatSidenavModule} from '@angular/material/sidenav';

// !TOOLTIPS

// !COMPONENTS
import {UILabelComponent} from './ui/label';
import {UIInputComponent} from './ui/input';
import {UIInputDefaultComponent} from './ui/input-default';
import {UITitleComponent} from './ui/title';
import {UITabsComponent} from './ui/tabs';
import {UILoadingComponent} from './ui/loading';
import {UIModalComponent} from './ui/modal';
import {UIInputTextComponent} from './ui/input-text';
import {UIInputNumberComponent} from './ui/input-number';
import {UIInputErrorsComponent} from './ui/input-errors';
import {UIFormEngineComponent} from './ui/form';
import {UIButtonComponent} from './ui/button';
import {KvPipe} from './pipes/kv.pipe';
import {UIToolbarComponent} from './ui/toolbar';
import {UIInputRadioComponent} from './ui/input-radio';
import {UIInputCheckboxesComponent} from './ui/input-checkboxes';
import {PrePipe} from './pipes/pre.pipe';
import {UIAutoresizeComponent} from './ui/autoresize';
import {UIInputDropdownComponent} from './ui/input-dropdown';
import {UIInputNumberComponentValidator} from './ui/input-number.validator';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FrameworkHttpInterceptor} from './http/interceptor';
import {UIInputDatePickerComponent} from './ui/input-date-picker';
import {MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {MAT_DATE_FORMATS} from '@angular/material/core';
import {MomentDateAdapterModule} from './ui/moment-date-adapter';
import {UIRetryComponent} from './ui/retry';
import {UIInputCheckboxComponent} from './ui/input-checkbox';
import {UITableComponent} from './ui/table';
import {UIInputYesNoComponent} from './ui/input-yes-no';
import {UIUploaderComponent} from './ui/uploader';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {UIInputRadioAcceptComponent} from './ui/input-radio-accept';
import {DateAgoPipe} from './pipes/dateago.pipe';
import {HoursandminutesPipe} from './pipes/hoursandminutes.pipe';
import {UIInputAutocompleterComponent} from './ui/input-autocompleter';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {UIAlertComponent} from './ui/alert';
import {UIPopupComponent} from './ui/popup';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {UIDirectiveDownload} from './ui/download';
import {UIInputEmailListComponent} from './ui/input-email-list';

const routes: Routes = [
	/*{
	  path: 'ui',
	  canActivate: [AuthGuardToken],
	  component: UITestPage
	}*/

];


export const MOMENTDATEFORMATSCUSTOMADAPTER: MatDateFormats = {
	parse: {
		dateInput: 'l',
	},
	display: {
		dateInput: 'l',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};


@NgModule({
	declarations: [
		UIInputEmailListComponent,
		UIAlertComponent,
		UILabelComponent,
		UITabsComponent,
		UIInputComponent,
		UITitleComponent,
		UILoadingComponent,
		UIModalComponent,
		UIInputDefaultComponent,
		UIInputTextComponent,
		UIInputNumberComponent,
		UIInputNumberComponentValidator,
		UIInputErrorsComponent,
		UIFormEngineComponent,
		UIButtonComponent,
		UIToolbarComponent,
		UIInputRadioComponent,
		UIInputCheckboxesComponent,
		UIAutoresizeComponent,
		UIInputDropdownComponent,
		UIInputDatePickerComponent,
		UIRetryComponent,
		UIInputCheckboxComponent,
		UITableComponent,
		UIInputYesNoComponent,
		UIInputAutocompleterComponent,
		KvPipe,
		PrePipe,
		DateAgoPipe,
		UIUploaderComponent,
		UIInputRadioAcceptComponent,
		HoursandminutesPipe,
		UIPopupComponent,
		UIDirectiveDownload
	],
	imports: [
		RouterModule.forChild(routes),
		MatDatepickerModule,
		MomentDateAdapterModule, // mandatory for date picker
		FormsModule,
		MatAutocompleteModule,
		CommonModule,
		ReactiveFormsModule,
		MatTooltipModule,

		HttpClientModule,
		MatSidenavModule, MatSelectModule, MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatInputModule
	],
	exports: [
		UIInputEmailListComponent,
		UIAlertComponent,
		UIPopupComponent,
		UILabelComponent,
		UITabsComponent,
		UIInputComponent,
		UITitleComponent,
		UILoadingComponent,
		UIModalComponent,
		UIInputAutocompleterComponent,
		UIInputDefaultComponent,
		UIInputTextComponent,
		UIInputNumberComponent,
		UIInputNumberComponentValidator,
		UIInputErrorsComponent,
		UIFormEngineComponent,
		UIButtonComponent,
		UIToolbarComponent,
		UIInputRadioComponent,
		UIInputCheckboxesComponent,
		UIAutoresizeComponent,
		UIInputDropdownComponent,
		UIInputDatePickerComponent,
		UIRetryComponent,
		UIInputCheckboxComponent,
		UITableComponent,
		UIInputYesNoComponent,
		KvPipe,
		PrePipe,
		DateAgoPipe,
		UIUploaderComponent,
		UIInputRadioAcceptComponent,
		HoursandminutesPipe,
		UIDirectiveDownload
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: FrameworkHttpInterceptor,
			multi: true
		},
		{provide: MAT_DATE_LOCALE, useValue: 'en-US'},
		{provide: MAT_DATE_FORMATS, useValue: MOMENTDATEFORMATSCUSTOMADAPTER}
	]
})
export class Framework {
}

